<template>
  <div class>
    <Header></Header>
    <div v-if="!contacts.is_completed" class="profile-wrap">
      <HelloWorld v-if="!$route.params.step && currentRoute !=='completeProfile'" :hello="hello"></HelloWorld>
      <div v-if="$route.params.step" class="container step-container">
        <div class="row">
          <div class="col-6 form-col">
            <span class="step-counter">Шаг {{$route.params.step}}</span>
            <component
              :is="componentId"
              :contacts="contacts"
              v-on:print="printing"
              v-on:save="save"
              @bind="files_bind"
              @unbind="files_unbind"
            ></component>
          </div>
          <div class="col-6 mocupwrap">
            <IphoneMoc :profile="contacts" screen="Profile"></IphoneMoc>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="contacts.is_completed" class="profile-wrap">
      <div class="container step-container">
        <div class="row">
          <div class="col-6 form-col">
            <CompletedProfile
              :contacts="contacts"
              v-on:print="printing"
              v-on:save="save"
              @cancel="cancel"
            ></CompletedProfile>
          </div>
          <div class="col-6 mocupwrap">
            <IphoneMoc :profile="contacts" screen="Profile"></IphoneMoc>
          </div>
        </div>
      </div>
    </div>
    <Complete v-if="currentRoute ==='completeProfile'" :complete="compl" class="profile-wrap"></Complete>
    <modal name="fotty-modal">
      <div class="modal-wrap">
        <div class="title">Пропустить заполнение профиля?</div>
        <div class="body">
          Можешь пропустить заполнение, но лучше заполнить его сейчас. Это займет не больше 2 минут
          <div class="btn-wrap">
            <button class="btn btn-primary" @click="close">Продолжить заполнять</button>
          </div>
        </div>
      </div>
    </modal>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import HelloWorld from "@/components/basic/HelloWorld.vue";
import Complete from "@/components/basic/Complete.vue";
import Step1 from "@/components/profile/Step1.vue";
import Step2 from "@/components/profile/Step2.vue";
import Step3 from "@/components/profile/Step3.vue";
import CompletedProfile from "@/components/profile/CompletedProfile.vue";
import IphoneMoc from "@/components/iphone/IphoneMoc.vue";
import UserService from "@/services/User.js";
import _ from "lodash";

export default {
  name: "Profile",
  components: {
    Header,
    Footer,
    HelloWorld,
    IphoneMoc,
    Step1,
    Step2,
    Step3,
    Complete,
    CompletedProfile
  },
  data() {
    return {
      contacts: _.cloneDeep(this.$store.state.user.user_info),
      currentRoute: this.$router.currentRoute.name,
      componentId: "CompletedProfile",
      hello: {
        pic: "hellow_profile.png",
        h1: "Добро пожаловать в Фотти",
        span:
          "Сейчас мы проведем тебя по нескольким шагам, чтобы помочь заполнить твой профиль. Это займёт всего несколько минут.",
        skip: "А можно пропустить эти прелюдия?",
        first_step: "/profile/step/1/"
      },
      compl: {
        h2: "Отлично, профиль заполнен!",
        span:
          "Ты стал ближе к увиличению личного среднего чека, инновационности и количества дополнительных продаж. Создавай приложения к своим мероприятиям, удивляй гостей и зарабатывай больше!",
        button: "Супер!"
      }
    };
  },
  methods: {
    close: function() {
      this.$modal.hide("fotty-modal");
    },
    printing: function(name, val, to_link = false) {
      if (!to_link) {
        if (name !== "name") this.contacts[name] = val;
        else this.contacts[name].value = val;
      } else {
        this.contacts["socials"][name].view = val;
      }
    },
    successSave: function() {
      this.$store.dispatch("user/auth");
      this.$router.push({ path: "/events/" });
      this.$notify({
        group: "success",
        title: "Успех",
        text: "Профиль успешно обновлен"
      });
    },
    errorSave: function(response) {
      this.$notify({
        group: "error",
        title: "Ошибка",
        text: response.data.message
      });
    },
    save: function() {
      // if (this.contacts.is_completed)
      this.$store
        .dispatch("user/save_user", this.contacts)
        .then(this.successSave)
        .catch(error => {
          this.errorSave(error.response);
        });
    },
    files_bind: function(type = "") {
      let obj = {};
      if (type === "layout") obj.id = this.contacts.layout_id;
      if (type === "avatar") obj.id = this.contacts.avatar_id;
      UserService.filesBind(type, obj).then(() => {});
    },
    files_unbind: function(type = "") {
      UserService.filesUnBind(type, this.$store.state.user_ver).then(() => {
        if (type === "avatar") {
          this.contacts.avatar = "";
          this.contacts.avatar_id = "";
        }
        if (type === "layout") {
          this.contacts.layout = "";
          this.contacts.layout_id = "";
        }
      });
    },

    skip: function() {
      this.$modal.show("fotty-modal");
    },
    complete: function() {
      this.$router.push({ path: "/events/" });
    },
    cancel: function() {
      this.contacts = _.cloneDeep(this.$store.getters["user/get_user"]);
    },
  },
  watch: {
    $route(to) {
      this.currentRoute = to.name;
      this.componentId = "Step" + to.params.step || "Step1";
    }
  },
  mounted() {
    if (this.$route.params.step > 3)
      this.$router.push({ path: "hello_profile" });
    else this.componentId = "Step" + this.$route.params.step || "Step1";
  },
};
</script>

<style lang="scss" scope>
.profile-wrap {
  min-height: calc(100vh - 112px);
}

.modal-wrap {
  max-width: none;
  .btn-wrap {
    margin-top: 67px;
    .btn {
      padding: 16px 37px;
      margin: 0 auto;
      display: block;
    }
  }
}
.step-container {
  padding-top: 80px;
  .form-col {
    .title {
      font-weight: bold;
      font-size: 32px;
      line-height: 40px;
      margin-bottom: 24px;
    }
    .description {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 66px;
      display: block;
    }
    .step-counter {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      color: #bbb;
      display: block;
      margin-bottom: 8px;
    }
    .btn-wrap {
      padding-top: 6px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 16px;
      .btn {
        padding: 16px 0;
      }
      a {
        @extend %bRadius;
        &.btn-primary {
          color: #fff !important;
        }
        &.btn-outline-primary {
          color: $primary !important;
          &:hover {
            color: #fff !important;
          }
        }
      }
    }
    .group {
      margin-bottom: 50px;
      &:last-child {
        margin-bottom: 56px;
      }
    }
  }
  .mocupwrap {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
